import React from 'react';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Chip from '../Chip';
import { FilterGroup } from '../ProductFiltering/types/FilterGroup';
import { FilterGroupType } from '../ProductFiltering/types/FilterGroupType';
import { clearFilterGroup } from '../../Actions/ProductFiltering.action';
import { translate } from '../../Services/translation';

interface FilterGroupChipsAttributes {
  filterGroup: FilterGroup;
}

const FilterGroupChips = (props: FilterGroupChipsAttributes) => {
  const dispatch = useDispatch();
  const { selectedOptions, id, label, filterGroupType } = props.filterGroup;

  const chipText = useMemo(() => selectedOptions.join(', '), [selectedOptions]);

  if (selectedOptions.length == 0) return null;

  return (
    <>
      {filterGroupType == FilterGroupType.Checkbox && (
        <Chip
          key={id + 'chip'}
          chipProps={{ title: chipText.length > 30 ? chipText : undefined }}
          onDeleteClick={() => dispatch(clearFilterGroup(id))}
        >
          <span>
            <strong>{label}: </strong>
            {chipText == 'InStock' && translate('filter.stockstatus.in-stock')}
            {chipText != 'InStock' && chipText.substring(0, 30)}
            {chipText.length > 30 ? '...' : ''}
          </span>
        </Chip>
      )}
      {filterGroupType == FilterGroupType.Range && selectedOptions.length == 2 && (
        <Chip onDeleteClick={() => dispatch(clearFilterGroup(id))}>
          <span>
            <strong>{label}:</strong> {selectedOptions[0]}-{selectedOptions[1]}
          </span>
        </Chip>
      )}
    </>
  );
};

export default FilterGroupChips;
